import React from 'react';
import { Row, Container, Button } from 'reactstrap';
import MissionsCardHome from './missionsCardHome';


class MissionsCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      missionsData: []
    }
  }


  render() {
    const { missions, title , activeTab} = this.props;

    return (
      <Container className="panel-padding " >
        {activeTab === "monthlygiving" ? null : 
        <>
          <h2 className="monthly-mission-heading">Monthly Giving Missions</h2>
          <div className="sub-divider-heading"></div>
        </> }
        <Row>
          {missions?.map((mission, indexma) => (
            <MissionsCardHome
              key={indexma}
              mission={mission}
            />
          ))}
        </Row>
        {/* <div className="d-flex justify-content-center align-self-center missions-panel-btm-view-all" >
                    <a className="text-center" href="" >
                        <Button className="btn-view-all-homepage homepage-btn-color">
                            View all causes you can support
                            </Button>
                    </a>
                </div> */}
        <style global jsx>
          {`
                          .btn-view-all-homepage{
                            display: inline-block;
                            font-weight: 100;
                            text-align: center;
                            white-space: nowrap;
                            vertical-align: middle;
                            user-select: none;
                            border: 1px solid transparent;
                            padding: 4px 9px;
                            font-size: 1rem;
                            line-height: 1.5 !important;
                            border-radius: 0.3rem;
                            font-family: Nunito Sans, sans-serif;                         
                            transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
                            text-decoration: none;
                        }
                        .homepage-btn-color{
                            padding: 0.3rem 2rem;
                            font-size: 16px;
                            line-height: 1.5 !important;
                            border-radius: 0.3rem;
                            color: #999999!important;
                            background-color: #fbfbfb!important;
                            border-color: #999999!important;
                            background-image: none;
                        }  
                        .missions-panel-btm-view-all{
                            padding-top: 2rem;
                            }
                            @media (max-width: 576px) {
                            .missions-panel-btm-view-all {
                            padding: 0px;
                            }                          
                        }     
                         `}
        </style>
      </Container>
    )
  }
}

export default MissionsCard;
